<template>
  <svg
    width="16"
    height="21"
    viewBox="0 0 16 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00008 0.833336C11.0342 0.833336 13.5001 3.27167 13.5001 6.2875C13.5001 10.3758 8.00008 16.4167 8.00008 16.4167C8.00008 16.4167 2.50008 10.3758 2.50008 6.2875C2.50008 3.27167 4.96591 0.833336 8.00008 0.833336ZM8.00008 4.5C7.51385 4.5 7.04754 4.69316 6.70372 5.03697C6.3599 5.38079 6.16675 5.84711 6.16675 6.33334C6.16675 6.81957 6.3599 7.28588 6.70372 7.6297C7.04754 7.97351 7.51385 8.16667 8.00008 8.16667C8.48631 8.16667 8.95263 7.97351 9.29644 7.6297C9.64026 7.28588 9.83341 6.81957 9.83341 6.33334C9.83341 5.84711 9.64026 5.38079 9.29644 5.03697C8.95263 4.69316 8.48631 4.5 8.00008 4.5ZM15.3334 16.4167C15.3334 18.4425 12.0517 20.0833 8.00008 20.0833C3.94841 20.0833 0.666748 18.4425 0.666748 16.4167C0.666748 15.2342 1.78508 14.18 3.51758 13.5108L4.10425 14.345C3.11425 14.7575 2.50008 15.3258 2.50008 15.9583C2.50008 17.2233 4.96591 18.25 8.00008 18.25C11.0342 18.25 13.5001 17.2233 13.5001 15.9583C13.5001 15.3258 12.8859 14.7575 11.8959 14.345L12.4826 13.5108C14.2151 14.18 15.3334 15.2342 15.3334 16.4167Z"
      fill="#B7BDCD"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
